<template>
    <base-button type="danger" size="sm" @click="handleClick" class="mr-2">
        <i class="fa fa-trash fa-fw"></i>Eliminar
    </base-button>
</template>
<script>
export default {
    name: "delete-button",
    methods: {
        handleClick(evt) {
            this.$emit("click", evt);
        }
    }
};
</script>
<style>
</style>